// Single source of truth for Canadian provinces, territories, and their
// cities and towns. Cities are ordered by approximate population within each
// province so the most likely picks surface first in every picker.
// Every province/city dropdown in the app should read from this file.

export const PROVINCES = [
  {
    code: "ON",
    name: "Ontario",
    lat: 43.6532,
    lng: -79.3832,
    cities: [
      "Toronto",
      "Ottawa",
      "Mississauga",
      "Brampton",
      "Hamilton",
      "London",
      "Markham",
      "Vaughan",
      "Kitchener",
      "Windsor",
      "Richmond Hill",
      "Oakville",
      "Burlington",
      "Oshawa",
      "Barrie",
      "St. Catharines",
      "Guelph",
      "Cambridge",
      "Whitby",
      "Kingston",
      "Ajax",
      "Milton",
      "Thunder Bay",
      "Waterloo",
      "Greater Sudbury",
      "Clarington",
      "Brantford",
      "Pickering",
      "Niagara Falls",
      "Newmarket",
      "Peterborough",
      "Kawartha Lakes",
      "Caledon",
      "Sarnia",
      "Halton Hills",
      "Sault Ste. Marie",
      "Welland",
      "Belleville",
      "Aurora",
      "North Bay",
      "Cornwall",
      "Chatham-Kent",
      "Georgina",
      "St. Thomas",
      "Woodstock",
      "Innisfil",
      "Quinte West",
      "Bradford",
      "New Tecumseth",
      "Timmins",
      "Orillia",
      "Stouffville",
      "East Gwillimbury",
      "Orangeville",
      "Stratford",
      "Fort Erie",
      "Leamington",
      "LaSalle",
      "Grimsby",
      "Clarence-Rockland",
      "Lincoln",
      "Tecumseh",
      "Amherstburg",
      "Brockville",
      "Owen Sound",
      "Collingwood",
      "Cobourg",
      "Wasaga Beach",
      "Pembroke",
      "Petawawa",
      "Strathroy",
      "Midland",
      "Port Colborne",
      "Thorold",
      "Niagara-on-the-Lake",
      "Port Hope",
      "Essex",
      "Huntsville",
      "Tillsonburg",
      "Ingersoll",
      "Carleton Place",
      "Uxbridge",
      "Lindsay",
      "Alliston",
      "Fergus",
      "Kenora",
      "Simcoe",
      "Smiths Falls",
      "Bracebridge",
      "Elliot Lake",
      "Gravenhurst",
      "Kincardine",
      "Port Elgin",
      "Hawkesbury",
      "Goderich",
      "Listowel",
      "Hanover",
      "Renfrew",
      "Arnprior",
      "Perth",
      "Napanee",
      "Kemptville",
      "Almonte",
      "St. Marys",
      "Kirkland Lake",
      "Kapuskasing",
      "Parry Sound",
      "Dryden",
      "Fort Frances",
      "Gananoque",
      "Espanola",
      "Walkerton",
      "Prescott",
      "Deep River",
    ],
  },
  {
    code: "QC",
    name: "Quebec",
    lat: 45.5019,
    lng: -73.5674,
    cities: [
      "Montreal",
      "Quebec City",
      "Laval",
      "Gatineau",
      "Longueuil",
      "Sherbrooke",
      "Lévis",
      "Saguenay",
      "Trois-Rivières",
      "Terrebonne",
      "Saint-Jean-sur-Richelieu",
      "Brossard",
      "Repentigny",
      "Drummondville",
      "Saint-Jérôme",
      "Granby",
      "Blainville",
      "Saint-Hyacinthe",
      "Mirabel",
      "Shawinigan",
      "Dollard-des-Ormeaux",
      "Rimouski",
      "Châteauguay",
      "Victoriaville",
      "Saint-Eustache",
      "Mascouche",
      "Salaberry-de-Valleyfield",
      "Rouyn-Noranda",
      "Boucherville",
      "Sorel-Tracy",
      "Côte Saint-Luc",
      "Vaudreuil-Dorion",
      "Val-d'Or",
      "Pointe-Claire",
      "Alma",
      "Sainte-Julie",
      "Saint-Constant",
      "Boisbriand",
      "Sainte-Thérèse",
      "Magog",
      "La Prairie",
      "Thetford Mines",
      "Sept-Îles",
      "Saint-Bruno-de-Montarville",
      "Chambly",
      "Baie-Comeau",
      "Saint-Lambert",
      "Beloeil",
      "Joliette",
      "Saint-Lazare",
      "Candiac",
      "L'Assomption",
      "Varennes",
      "Kirkland",
      "Beaconsfield",
      "Mont-Royal",
      "Westmount",
      "Dorval",
      "Deux-Montagnes",
      "Sainte-Catherine",
      "Saint-Augustin-de-Desmaures",
      "L'Ancienne-Lorette",
      "Mont-Saint-Hilaire",
      "Rivière-du-Loup",
      "Cowansville",
      "Matane",
      "Amos",
      "Lachute",
      "Mont-Laurier",
      "Dolbeau-Mistassini",
      "Gaspé",
      "Montmagny",
      "Sainte-Agathe-des-Monts",
      "Mont-Tremblant",
      "Bromont",
      "Saint-Sauveur",
      "La Tuque",
      "Roberval",
      "Baie-Saint-Paul",
    ],
  },
  {
    code: "BC",
    name: "British Columbia",
    lat: 49.2827,
    lng: -123.1207,
    cities: [
      "Vancouver",
      "Surrey",
      "Burnaby",
      "Richmond",
      "Abbotsford",
      "Coquitlam",
      "Kelowna",
      "Saanich",
      "Delta",
      "Langley",
      "Kamloops",
      "Nanaimo",
      "Victoria",
      "Chilliwack",
      "Maple Ridge",
      "Prince George",
      "New Westminster",
      "Port Coquitlam",
      "North Vancouver",
      "Langford",
      "Vernon",
      "Mission",
      "Penticton",
      "Campbell River",
      "West Kelowna",
      "Port Moody",
      "Courtenay",
      "West Vancouver",
      "Salmon Arm",
      "Fort St. John",
      "Cranbrook",
      "White Rock",
      "Squamish",
      "Pitt Meadows",
      "Port Alberni",
      "Colwood",
      "Esquimalt",
      "Oak Bay",
      "Central Saanich",
      "Duncan",
      "Comox",
      "Prince Rupert",
      "Terrace",
      "Powell River",
      "Whistler",
      "Sidney",
      "Parksville",
      "Dawson Creek",
      "Quesnel",
      "Williams Lake",
      "Sooke",
      "Nelson",
      "Trail",
      "Castlegar",
      "Kitimat",
      "Summerland",
      "Sechelt",
      "Ladysmith",
      "Qualicum Beach",
      "Merritt",
      "Kimberley",
      "Revelstoke",
      "Osoyoos",
      "Smithers",
      "Fernie",
      "Hope",
      "Oliver",
      "Gibsons",
      "Golden",
      "Tofino",
      "Ucluelet",
    ],
  },
  {
    code: "AB",
    name: "Alberta",
    lat: 51.0447,
    lng: -114.0719,
    cities: [
      "Calgary",
      "Edmonton",
      "Red Deer",
      "Lethbridge",
      "St. Albert",
      "Sherwood Park",
      "Airdrie",
      "Medicine Hat",
      "Grande Prairie",
      "Fort McMurray",
      "Spruce Grove",
      "Leduc",
      "Cochrane",
      "Okotoks",
      "Fort Saskatchewan",
      "Chestermere",
      "Beaumont",
      "Camrose",
      "Stony Plain",
      "Sylvan Lake",
      "Canmore",
      "Brooks",
      "Strathmore",
      "High River",
      "Lacombe",
      "Wetaskiwin",
      "Lloydminster",
      "Cold Lake",
      "Blackfalds",
      "Morinville",
      "Taber",
      "Coaldale",
      "Banff",
      "Whitecourt",
      "Hinton",
      "Olds",
      "Edson",
      "Innisfail",
      "Drumheller",
      "Ponoka",
      "Drayton Valley",
      "Slave Lake",
      "Rocky Mountain House",
      "Wainwright",
      "Stettler",
      "St. Paul",
      "Vegreville",
      "Bonnyville",
      "Devon",
      "Peace River",
      "Didsbury",
      "Jasper",
    ],
  },
  {
    code: "MB",
    name: "Manitoba",
    lat: 49.8951,
    lng: -97.1384,
    cities: [
      "Winnipeg",
      "Brandon",
      "Steinbach",
      "Winkler",
      "Thompson",
      "Portage la Prairie",
      "Selkirk",
      "Morden",
      "Dauphin",
      "The Pas",
      "Niverville",
      "Flin Flon",
      "Stonewall",
      "Altona",
      "Oakbank",
      "Neepawa",
      "Beausejour",
      "Carman",
      "Virden",
      "Gimli",
      "Swan River",
      "Headingley",
      "Morris",
      "Killarney",
      "Lac du Bonnet",
      "Roblin",
    ],
  },
  {
    code: "SK",
    name: "Saskatchewan",
    lat: 52.1332,
    lng: -106.67,
    cities: [
      "Saskatoon",
      "Regina",
      "Prince Albert",
      "Moose Jaw",
      "Swift Current",
      "Yorkton",
      "North Battleford",
      "Warman",
      "Estevan",
      "Weyburn",
      "Martensville",
      "Melfort",
      "Humboldt",
      "Meadow Lake",
      "Melville",
      "Kindersley",
      "Battleford",
      "Nipawin",
      "Tisdale",
      "La Ronge",
      "Moosomin",
      "Assiniboia",
      "Unity",
      "Rosetown",
      "Outlook",
      "Esterhazy",
    ],
  },
  {
    code: "NS",
    name: "Nova Scotia",
    lat: 44.6488,
    lng: -63.5752,
    cities: [
      "Halifax",
      "Dartmouth",
      "Sydney",
      "Truro",
      "New Glasgow",
      "Glace Bay",
      "Kentville",
      "Amherst",
      "Bridgewater",
      "Yarmouth",
      "Antigonish",
      "Wolfville",
      "Windsor",
      "Stellarton",
      "Port Hawkesbury",
      "Pictou",
      "Digby",
      "Berwick",
      "Middleton",
      "Liverpool",
      "Lunenburg",
      "Shelburne",
    ],
  },
  {
    code: "NB",
    name: "New Brunswick",
    lat: 46.0878,
    lng: -64.7782,
    cities: [
      "Moncton",
      "Saint John",
      "Fredericton",
      "Dieppe",
      "Riverview",
      "Quispamsis",
      "Miramichi",
      "Edmundston",
      "Rothesay",
      "Bathurst",
      "Oromocto",
      "Campbellton",
      "Grand Falls",
      "Shediac",
      "Tracadie",
      "Sackville",
      "Woodstock",
      "Sussex",
      "Caraquet",
      "Grand Bay-Westfield",
      "St. Stephen",
      "Dalhousie",
    ],
  },
  {
    code: "NL",
    name: "Newfoundland and Labrador",
    lat: 47.5615,
    lng: -52.7126,
    cities: [
      "St. John's",
      "Conception Bay South",
      "Mount Pearl",
      "Paradise",
      "Corner Brook",
      "Grand Falls-Windsor",
      "Gander",
      "Portugal Cove-St. Philip's",
      "Torbay",
      "Happy Valley-Goose Bay",
      "Labrador City",
      "Stephenville",
      "Clarenville",
      "Bay Roberts",
      "Marystown",
      "Deer Lake",
      "Carbonear",
      "Channel-Port aux Basques",
    ],
  },
  {
    code: "PE",
    name: "Prince Edward Island",
    lat: 46.2382,
    lng: -63.1311,
    cities: [
      "Charlottetown",
      "Summerside",
      "Stratford",
      "Cornwall",
      "Montague",
      "Kensington",
      "Souris",
      "Alberton",
      "Tignish",
    ],
  },
  {
    code: "YT",
    name: "Yukon",
    lat: 60.7212,
    lng: -135.0568,
    cities: [
      "Whitehorse",
      "Dawson City",
      "Watson Lake",
      "Haines Junction",
      "Carmacks",
      "Faro",
      "Mayo",
      "Teslin",
    ],
  },
  {
    code: "NT",
    name: "Northwest Territories",
    lat: 62.454,
    lng: -114.3718,
    cities: [
      "Yellowknife",
      "Hay River",
      "Inuvik",
      "Fort Smith",
      "Behchoko",
      "Fort Simpson",
      "Norman Wells",
      "Fort Providence",
      "Tuktoyaktuk",
    ],
  },
  {
    code: "NU",
    name: "Nunavut",
    lat: 63.7467,
    lng: -68.517,
    cities: [
      "Iqaluit",
      "Rankin Inlet",
      "Arviat",
      "Baker Lake",
      "Cambridge Bay",
      "Igloolik",
      "Pond Inlet",
      "Pangnirtung",
      "Kugluktuk",
      "Kinngait",
      "Gjoa Haven",
    ],
  },
];

// Cities for a province/territory code, e.g. citiesFor("ON") -> ["Toronto", ...].
// Returns an empty array for unknown codes so callers can render safely.
export function citiesFor(code) {
  const p = PROVINCES.find((x) => x.code === code);
  return p ? p.cities : [];
}

// { value, label } pairs for plain <select> province dropdowns.
export const PROVINCE_OPTIONS = PROVINCES.map((p) => ({ value: p.code, label: p.name }));

// Approximate coordinates of each province's largest city, for map centering
// when a chosen city has no exact coordinates of its own.
export function provinceAnchor(code) {
  const p = PROVINCES.find((x) => x.code === code);
  return p ? { lat: p.lat, lng: p.lng } : null;
}
